<template>
  <section>
    <div
      class="news-banner tw-text-white tw-text-center tw-mb-4 tw-pt-8 tw-pb-56 tw-rounded-2xl md:tw-text-left md:tw-rounded-4xl md:tw-mt-6 md:tw-mb-14 md:tw-py-20 md:tw-pl-28"
    >
      <div class="path"></div>

      <h1 class="tw-font-bold tw-text-[2.5rem] md:tw-mb-2 md:tw-text-5xl">Newsroom</h1>
      <p class="tw-text-xl tw-text-primary tw-mb-4 md:tw-mb-8">FOLLOW US</p>
      <p class="tw-mb-4 tw-h-12 md:tw-mb-8 md:tw-h-16">
        <a href="https://www.linkedin.com/company/legend-trading" target="_blank" class="tw-mr-4">
          <button class="tw-btn tw-btn-circle lg:tw-btn-lg">
            <SvgoMenuLinkedIn class="tw-w-6 lg:tw-w-8" />
          </button>
        </a>
        <a v-if="!isEu" href="https://x.com/LegendTradingX" target="_blank">
          <button class="tw-btn tw-btn-circle lg:tw-btn-lg">
            <SvgoMenuX class="tw-w-6 lg:tw-w-8" />
          </button>
        </a>
      </p>

      <p class="tw-font-semibold tw-text-xl md:tw-leading-loose">Media Enquiries</p>
      <a class="tw-text-lg tw-text-primary tw-underline tw-underline-offset-2 hover:tw-text-white" :href="`mailto:${email}`">
        {{ email }}
      </a>
    </div>

    <RepostFeed class="tw-mb-24" :limit="6" @view-article="$emit('view-article', $event)" />

    <div class="dashed-line tw-mt-14 md:tw-mt-32"></div>

    <p class="tw-mt-14 tw-mb-8 tw-text-center tw-font-semibold tw-text-4xl md:tw-mt-8 md:tw-mb-8"
      >Get in touch for media & partnership enquiries</p
    >
    <p class="tw-mb-16 tw-text-center">
      <a
        class="tw-text-xl tw-font-semibold tw-text-primary tw-underline tw-underline-offset-2 hover:tw-text-black md:tw-text-lg md:tw-font-normal"
        :href="`mailto:${email}`"
      >
        {{ email }}
      </a>
    </p>
  </section>
</template>

<script setup lang="ts">
  defineProps(['email'])
  const { isEu } = useSite()
</script>

<style scoped lang="scss">
  .news-banner {
    background-image: radial-gradient(circle at 64% 60%, #4598ef, rgba(69, 152, 239, 0) 20%), linear-gradient(to bottom, #111224, #111224);
    overflow: hidden;
    position: relative;
    & > .path {
      pointer-events: none;
      user-select: none;
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      background-image: url('/res/img/newsroom/banner-02.png');
      background-size: cover;
      background-position: 50% 100%;
    }
    & > h1,
    p,
    a {
      position: relative;
    }
  }
  .dashed-line {
    height: 2px;
    background: linear-gradient(to right, transparent 50%, #ffffff 50%),
      linear-gradient(
        to right,
        rgba(224, 224, 224, 0) 5%,
        rgba(224, 224, 224, 0.9) 25%,
        rgba(224, 224, 224, 0.9) 75%,
        rgba(224, 224, 224, 0) 95%
      );
    background-size: 18px 2px, 100% 2px;
  }

  @media (min-width: 960px) {
    .news-banner {
      & > .path {
        background-image: url('/res/img/newsroom/banner-01.png');
        background-position: 100% 0;
      }
    }
  }
</style>
